<template>
  <div class="admin-layout">
    <AdminHeader @logout="handleLogout" />
    <div class="admin-container">
      <slot />
    </div>
  </div>
</template>

<script>
import AdminHeader from './AdminHeader.vue'

export default {
  name: 'AdminLayout',
  components: {
    AdminHeader
  },
  methods: {
    handleLogout() {
      // 清除存储的用户信息
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('userRole')
      localStorage.removeItem('adminEmail')

      // 清除所有cookie
      document.cookie.split(";").forEach(function(c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });

      // 跳转到登录页
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.admin-layout {
  padding: var(--spacing-xl);
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
  background: var(--bg-primary);
}

.admin-container {
  background: var(--bg-white);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-xxl);
  box-shadow: var(--shadow-md);
}

@media (max-width: 768px) {
  .admin-layout {
    padding: var(--spacing-lg);
  }

  .admin-container {
    padding: var(--spacing-xl);
  }
}
</style>